var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230px",
    height: "150px",
    viewBox: "0 0 230 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19C6A215-4DD5-459C-93FF-4DED0C31AADD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Page/Payment-Success-Icon/Page/Payment-Failed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(55.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.64,0.317010309 L9.36,0.317010309 C4.212,0.317010309 0,4.50154639 0,9.61597938 L0,72.1515464 C0,77.2659794 4.212,81.4505155 9.36,81.4505155 L107.64,81.4505155 C112.788,81.4505155 117,77.2659794 117,72.1515464 L117,9.61597938 C117,4.50154639 112.788,0.317010309 107.64,0.317010309 Z M112.32,72.3840206 C112.32,74.9412371 110.214,77.0335052 107.64,77.0335052 L9.36,77.0335052 C6.786,77.0335052 4.68,74.9412371 4.68,72.3840206 L4.68,35.1881443 L112.32,35.1881443 L112.32,72.3840206 Z M112.32,30.3061856 L4.68,30.3061856 L4.68,21.2396907 L112.32,21.2396907 L112.32,30.3061856 Z M112.32,16.5902062 L4.68,16.5902062 L4.68,9.84845361 C4.68,7.29123711 6.786,5.19896907 9.36,5.19896907 L107.64,5.19896907 C110.214,5.19896907 112.32,7.29123711 112.32,9.84845361 L112.32,16.5902062 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.092,66.3396907 C81.198,66.3396907 83.07,65.8747423 84.708,64.7123711 C86.346,65.642268 88.218,66.3396907 90.324,66.3396907 C95.94,66.3396907 100.62,61.6902062 100.62,55.8783505 C100.62,50.2989691 95.94,45.6494845 90.324,45.6494845 C88.218,45.6494845 86.346,46.3469072 84.708,47.2768041 C83.07,46.114433 81.198,45.6494845 79.092,45.6494845 C73.476,45.6494845 68.796,50.2989691 68.796,55.8783505 C68.562,61.6902062 73.242,66.3396907 79.092,66.3396907 Z M90.324,50.2989691 C93.366,50.2989691 95.94,52.8561856 95.94,55.8783505 C95.94,59.1329897 93.366,61.6902062 90.324,61.6902062 C87.282,61.6902062 84.708,59.1329897 84.708,55.8783505 C84.474,52.8561856 87.048,50.2989691 90.324,50.2989691 Z M79.092,50.2989691 C79.794,50.2989691 80.73,50.5314433 81.432,50.7639175 C80.496,52.3912371 80.028,54.0185567 80.028,55.8783505 C80.028,57.7381443 80.496,59.5979381 81.432,60.9927835 C80.73,61.2252577 80.028,61.457732 79.092,61.457732 C76.05,61.457732 73.476,58.9005155 73.476,55.6458763 C73.242,52.8561856 75.816,50.2989691 79.092,50.2989691 Z M16.38,53.0886598 L43.992,53.0886598 C45.396,53.0886598 46.332,52.1587629 46.332,50.7639175 C46.332,49.3690722 45.396,48.4391753 43.992,48.4391753 L16.38,48.4391753 C14.976,48.4391753 14.04,49.3690722 14.04,50.7639175 C14.04,52.1587629 14.976,53.0886598 16.38,53.0886598 Z M16.38,63.3175258 L58.5,63.3175258 C59.904,63.3175258 60.84,62.3876289 60.84,60.9927835 C60.84,59.5979381 59.904,58.6680412 58.5,58.6680412 L16.38,58.6680412 C14.976,58.6680412 14.04,59.5979381 14.04,60.9927835 C14.04,62.3876289 14.976,63.3175258 16.38,63.3175258 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(106.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#D54E4E",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(17.500000, 17.749495) rotate(-315.000000) translate(-17.500000, -17.749495) ",
    points: "27 19.8606061 19.8989899 19.8606061 19.8989899 27.4989899 15.0626263 27.4989899 15.0626263 19.8606061 8 19.8606061 8 15.6 15.0626263 15.6 15.0626263 8 19.8989899 8 19.8989899 15.6 27 15.6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/payment_error.84a45432b4a89662ab46fc37ea38faa6.svg";
export { ForwardRef as ReactComponent };